// extracted by mini-css-extract-plugin
export default {"itemList":"ItemList_itemList__ojpP+","load":"ItemList_load__J0jey","loadText":"ItemList_loadText__x-CO1","margin":"ItemList_margin__gu6-K"};